import { useQuery } from 'react-query';
import { fetcher, performanceReportingApiUrl, ServerErrorResponse } from 'data_sources/constants';
import { FieldTypesResponse } from '../_types';

export const getFieldTypes = async (
  signal?: AbortSignal,
  onError?: (errors: ServerErrorResponse) => void,
): Promise<FieldTypesResponse> => {
  try {
    const url = `${performanceReportingApiUrl()}/performance/fields/v1/field-types`;
    const resp = await fetcher({
      method: 'get',
      url,
      options: { signal },
    });

    return resp as FieldTypesResponse;
  } catch (error: unknown) {
    if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
      onError(error as ServerErrorResponse);
    }
    throw error;
  }
};

export const useFieldTypes = (options = {}, onError?: (errors: ServerErrorResponse) => void) => {
  return useQuery({
    queryKey: ['field-types'],
    queryFn: ({ signal }) => getFieldTypes(signal, onError),
    ...options,
  });
};
